/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import AREA_SEARCH from "./AREA_SEARCH";
import AREA_HIRARKI from "./AREA_HIRARKI";
import SS_INPUT_GRID from "./SS_INPUT_GRID";
import SS_TEMPLATE from "./SS_TEMPLATE";
import SS_AI from "./SS_AI";
import SS_MANUAL from "./SS_MANUAL";
import SS_RESULT_SAVED from "./SS_RESULT_SAVED";

/*REDUX*/
import {
  get_list_tipe_1,
  get_list_tipe_2,
  get_list_tipe_3,
  set_value_insight,
} from "../../App/actions/insight_v2";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const SITE_SELECTION = ({
  auth,
  insight_reducer,
  get_list_tipe_1,
  get_list_tipe_2,
  get_list_tipe_3,
  set_value_insight,
}) => {
  //local storage
  const language = localStorage?.language || auth.language;

  //local state
  const [state, setState] = useState({
    mode_input: "single_input", //hirarki || single_input
  });
  const { mode_input } = state;

  //global props
  const { menu_formula, site_selection_view } = insight_reducer;

  useEffect(() => {
    const { list_tipe_1, list_tipe_2, list_tipe_3 } = insight_reducer;
    if (list_tipe_1.length === 0) {
      get_list_tipe_1();
    }
    if (list_tipe_2.length === 0) {
      get_list_tipe_2();
    }
    if (list_tipe_3.length === 0) {
      get_list_tipe_3();
    }
  }, [insight_reducer, get_list_tipe_1, get_list_tipe_2, get_list_tipe_3]);

  const on_set_mode_input = (mode_input) => {
    setState((prevState) => ({ ...prevState, mode_input }));
  };

  const on_set_menu_formula = (menu_formula) => {
    set_value_insight({
      key: "menu_formula",
      value: menu_formula,
    });
  };

  //content
  let input_area_content = <AREA_SEARCH />;
  if (mode_input === "hirarki") {
    input_area_content = <AREA_HIRARKI />;
  }

  const ss_input = (
    <main>
      <div className="text_bold">{dict?.["Search Location"]?.[language]}</div>

      <br />

      <button
        className={`text_medium margin_right margin_bottom ${
          mode_input === "single_input" ? "underline_active" : "sub_color"
        }`}
        onClick={() => on_set_mode_input("single_input")}
      >
        {dict?.["Search"]?.[language]}
      </button>
      <button
        className={`text_medium margin_right margin_bottom ${
          mode_input === "hirarki" ? "underline_active" : "sub_color"
        }`}
        onClick={() => on_set_mode_input("hirarki")}
        data-mapid="clickAdminisTrasi"
      >
        {dict?.["Administration Level"]?.[language]}
      </button>

      {input_area_content}

      <br />
      <br />

      <div className="text_bold">{dict?.["Set Grid"]?.[language]}</div>

      <br />
      <SS_INPUT_GRID />

      <br />
      <br />

      <div className="text_bold">{dict?.["Create a Formula"]?.[language]}</div>

      <br />

      <div className="menu_container_basic background_grey_light three_container margin_bottom">
        <button
          className={`button full_width ${
            menu_formula === "manual"
              ? "background_white"
              : "background_grey_light"
          }`}
          onClick={() => on_set_menu_formula("manual")}
          title={
            dict?.["Create a site selection formula according to your needs"]?.[
              language
            ]
          }
          data-mapid="clickParameter"
        >
          Parameter
        </button>
        <button
          className={`button full_width ${
            menu_formula === "template"
              ? "background_white"
              : "background_grey_light"
          }`}
          onClick={() => on_set_menu_formula("template")}
          title={
            dict?.[
              "Choose from templates that MAPID has provided or from templates that you have saved."
            ]?.[language]
          }
          data-mapid="clickTemplate"
        >
          Template
        </button>
        <button
          className={`button full_width ${
            menu_formula === "ai" ? "background_white" : "background_grey_light"
          }`}
          onClick={() => on_set_menu_formula("ai")}
          title={dict?.["Use AI to help create formulas"]?.[language]}
          data-mapid="clickAI"
        >
          AI
        </button>
      </div>

      {menu_formula === "manual" ? (
        <SS_MANUAL />
      ) : menu_formula === "template" ? (
        <SS_TEMPLATE />
      ) : (
        <SS_AI />
      )}
    </main>
  );

  return (
    <main className="margin_bottom_extra">
      {site_selection_view === "input" ? ss_input : <SS_RESULT_SAVED />}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  map: state.map,
  layer: state.layer,
  project: state.project,
  payment: state.payment,
  properties: state.properties,
  sini: state.sini,
  license_reducer: state.license_reducer,
  insight_reducer: state.insight_reducer,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, {
  get_list_tipe_1,
  get_list_tipe_2,
  get_list_tipe_3,
  set_value_insight,
})(SITE_SELECTION);
